import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams, ReceivingFileModel } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { BusinessappsModel, CreateBusinessappsModel } from 'Pages/orders'

export type BusinessappsState = {
	reload: boolean
	list: ResponseCatalog<BusinessappsModel>
	edit: BusinessappsModel | null
	requestParams: RequestParams
	isLoading: boolean
}

export const businessappsInitialState: BusinessappsState = {
	reload: false,
	list: new ResponseCatalog<BusinessappsModel>(),
	edit: null,
	requestParams: new RequestParams(),
	isLoading: false,
}

export namespace BusinessappssNS {
	export type GetBusinessappsList = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type GetOne = PayloadAction<string>
	export type SetOne = PayloadAction<BusinessappsModel>
	export type UpdateOne = PayloadAction<{
		id: string
		data: CreateBusinessappsModel
		callback?: Function
		initialFile?: ReceivingFileModel
	}>
	export type CreateOne = PayloadAction<CreateBusinessappsModel>
	export type DeleteOne = PayloadAction<string>
	export type SetBusinessappsList = PayloadAction<ResponseCatalog<BusinessappsModel>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type SetIsLoading = PayloadAction<boolean>
}

export const businessappsSlice = createSlice({
	name: 'businessapps',
	initialState: businessappsInitialState,
	reducers: {
		getBusinessappsList: (state, action: BusinessappssNS.GetBusinessappsList) => {},
		setBusinessappsList: (state, action: BusinessappssNS.SetBusinessappsList) => {
			state.reload = state?.reload ?? false
			state.list = action.payload
		},
		setRequestParams: (state, action: BusinessappssNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.list = new ResponseCatalog<BusinessappsModel>()
			state.requestParams = new RequestParams()
		},
		setIsLoading: (state, action: BusinessappssNS.SetIsLoading) => {
			state.isLoading = action.payload
		},
		getOne: (state, action: BusinessappssNS.GetOne) => {},
		setOne: (state, action: BusinessappssNS.SetOne) => {
			state.edit = action.payload
		},
		updateOne: (state, action: BusinessappssNS.UpdateOne) => {},
		createOne: (state, action: BusinessappssNS.CreateOne) => {},
		deleteOne: (state, action: BusinessappssNS.DeleteOne) => {},
	},
})
